module.exports = __webpack_public_path__ + "static/media/buyer-banner-center-img.65b1f0c2.png";